import { Breadcrumb, Button, Card, Col, Empty, Form, Input, message, Row, Table } from 'antd';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import gql from 'graphql-tag';
import queryString from 'query-string';
import React, { Component, FormEvent } from 'react';
import { Query } from 'react-apollo';
import { Link, RouteComponentProps } from 'react-router-dom';
import { mobileMasking } from 'src/utils/masking';

import { Panel } from '../../components/Panel';
import { User } from './Users';

const FormItem = Form.Item;

const DEFAULT_QUERY_SIZE = 100;

export const ALL_USERS_QUERY = gql`
  query GetAllUsers($mobile: String, $name: String, $take: Int, $skip: Int, $ids: [ID]) {
    users(mobile: $mobile, name: $name, take: $take, skip: $skip, ids: $ids) {
      id
      name
      mobile
      gender
      region
      enrollments {
        id
      }
    }
  }
`;

interface UserListData {
  users: User[];
}

interface Props {
  form: WrappedFormUtils;
}
type AllProps = RouteComponentProps<{}> & Props;

interface State {
  expand: boolean;
  pageSize: number;
  current: number;
  variables: {
    mobile?: string;
    name?: string;
    take: number;
    ids?: string;
  };
}

export class UserListForm extends Component<AllProps, State> {
  constructor(props: AllProps) {
    super(props);
    this.state = {
      expand: false,
      pageSize: 10,
      current: 1,
      variables: {
        take: DEFAULT_QUERY_SIZE,
      },
    };

    this.search = this.search.bind(this);
    this.onResetClick = this.onResetClick.bind(this);
  }
  async componentDidMount() {
    this.props.form.validateFields();
    const {
      location: { search },
    } = this.props;
    const { pageIndex } = queryString.parse(search);
    if (pageIndex) {
      this.setState({
        current: Number(pageIndex),
      });
    }
  }

  toSelectChange = (current: number) => {
    this.setState({
      current,
    });
  };

  setCurrent = (current: number) => {
    this.setState({
      current,
    });
  };

  toggle = () => {
    const { expand } = this.state;
    this.setState({ expand: !expand });
  };

  search(e: FormEvent) {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (err) {
        message.error(err);
        return;
      }
      this.setState({
        variables: {
          mobile: values.mobile,
          name: values.nickName,
          take: DEFAULT_QUERY_SIZE,
          ids: values.userId !== '' ? values.userId : undefined,
        },
      });
    });
  }
  onResetClick() {
    this.props.form.resetFields();
  }

  render() {
    const columns = [
      {
        title: '用户ID',
        dataIndex: 'id',
        key: 'id',
      },
      {
        title: '手机号码',
        dataIndex: 'mobile',
        key: 'mobile',
      },
      {
        title: '微信昵称',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: '课程数量',
        dataIndex: 'enrollments.length',
        key: 'enrollmentsLength',
      },
      {
        title: '操作',
        dataIndex: 'id',
        key: 'action',
        render: (userId: number) => <Link to={`/user/${userId}`}>详情</Link>,
      },
    ];
    const { getFieldDecorator } = this.props.form;
    return (
      <>
        <Breadcrumb style={{ marginBottom: 10, fontSize: 13 }}>
          <Breadcrumb.Item>
            <Link to={`/Home`}>首页</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>会员管理</Breadcrumb.Item>
        </Breadcrumb>
        <Card>
          <Form onSubmit={this.search}>
            <Row gutter={24}>
              <Col xs={24} md={24} lg={8} xl={8} xxl={8}>
                <FormItem label={`用户ID`}>
                  {getFieldDecorator('userId')(<Input placeholder="请输入用户ID" allowClear />)}
                </FormItem>
              </Col>
              <Col xs={24} md={24} lg={8} xl={8} xxl={8}>
                <FormItem label={`手机号码`}>
                  {getFieldDecorator('mobile')(<Input placeholder="请输入手机后4位" allowClear />)}
                </FormItem>
              </Col>
              <Col xs={24} md={24} lg={8} xl={8} xxl={8}>
                <FormItem label={`微信昵称`}>
                  {getFieldDecorator('nickName')(<Input placeholder="请输入微信昵称" allowClear />)}
                </FormItem>
              </Col>
            </Row>
            <Row type="flex" justify="end">
              <Button icon="search" type="primary" style={{ marginRight: 8 }} htmlType="submit">
                搜索
              </Button>
              <Button style={{ marginRight: 8 }} type="primary" onClick={this.onResetClick}>
                重置
              </Button>
              <Button style={{ marginRight: 8 }} icon="download">
                导出
              </Button>
            </Row>
          </Form>
        </Card>
        <Query<UserListData> query={ALL_USERS_QUERY} variables={this.state.variables}>
          {({ loading, error, data }) => {
            if (error) return <div>{error.message}</div>;
            if (loading) return <div>loading...</div>;
            if (!data) {
              // @ts-ignore
              return <Empty />;
            }

            const users = (data && data.users) || [];
            const newUsers = JSON.parse(JSON.stringify(users));
            const maskedMobileUsers: User[] = newUsers.map(user => {
              if (user.mobile) {
                user.mobile = mobileMasking(user.mobile);
              }
              return user;
            });

            const UserTable = (
              <Panel style={{ marginTop: 16 }}>
                <Table
                  columns={columns}
                  dataSource={maskedMobileUsers}
                  loading={loading}
                  rowKey={user => `${user.id}`}
                  pagination={{
                    // 分页
                    current: this.state.current,
                    total: users.length, // 数据总数量
                    pageSize: this.state.pageSize, // 显示几条一页
                    defaultPageSize: 10, // 默认显示几条一页
                    showSizeChanger: true, // 是否显示可以设置几条一页的选项
                    onShowSizeChange: current => {
                      this.toSelectChange(current);
                    },
                    onChange: current => {
                      // 点击改变页数的选项时调用函数，current:将要跳转的页数
                      this.setCurrent(current);
                      this.props.history.push(`/user/list?pageIndex=${current}`);
                    },
                    showTotal: () => {
                      // 设置显示一共几条数据
                      return `共 ${users.length} 用户`;
                    },
                  }}
                />
              </Panel>
            );
            return UserTable;
          }}
        </Query>
      </>
    );
  }
}

export const UserList = Form.create({ name: 'UserList' })(UserListForm);



// WEBPACK FOOTER //
// ./src/screens/user/UserList.tsx